var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"dialog-msg",class:( _obj = {}, _obj[_vm.size] = true, _obj )},[_c('span',{staticClass:"before-text"},[_vm._t("before-text")],2),_c('span',{staticClass:"text text--info"},[_vm._t("text")],2),_c('span',{staticClass:"actions"},[_vm._t("actions")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }